.container {
  background-color: var(--colors-grays-ultralight);
  border-radius: 40px;
  margin-top: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.firstLine {
  display: flex;
  color: var(--colors-text-main);
  width: 100%;
}

.viewMoreLess {
  margin-left: 8px;
}

.toggleText {
  width: max-content;
}

.message {
  align-items: center;
  color: var(--colors-text-main);
  margin-top: 8px;
  margin-bottom: 24px;

  a {
    text-decoration: underline;
    color: #06c;
  }

  p {
    font-family: inherit;
    font-weight: var(--font-weight-regular);
    line-height: 24px;
    font-size: 16px;
  }
}
